import React from 'react';
import { TotalLine } from './Lines';
import { Price } from './Price';
import Currency from '../../common/intl/Currency';
import { DoubleDagger } from '../../common/notifications/NotificationsTrigger';
import MathBoxGroup from './MathBoxGroup';

const AccessoriesGroup = ({ pricing, isSummary }) => {
  const { accessoriesTotal } = pricing;

  if (!accessoriesTotal || isSummary) {
    return null;
  }

  return (
    <MathBoxGroup>
      <TotalLine
        labelKey="accessories.price.label"
        price={
          <Price>
            +<Currency value={accessoriesTotal} />{' '}
            <DoubleDagger disabled={true} />
          </Price>
        }
        className="math-box__line--accessories"
      />
    </MathBoxGroup>
  );
};

export default AccessoriesGroup;
